import { WorkSheetProductStatusURLs } from '../../../../specificComponents/inputTableLayouts/order/WorkSheetLayout/WorkSheetProductStatusFlow/WorkSheetProductStatusFlowInner/types'

const useWorkSheetProductStatusUrls = () => {
    const workSheetProductStatusUrl: WorkSheetProductStatusURLs = {
        updateProductStatus: '/api/app/order/sell/workSheet/workSheetProduct/updateWorkSheetProduct',
        getProducts: '/api/app/order/sell/workSheet/workSheetProduct/getAllWorkSheetProductsCompleteForStatusFlow',
        handleProductStatus: '/api/app/order/sell/workSheet/workSheetProduct/handleWorkSheetProductsStatusByStatusFlow',
        groupProductByStatus: '/api/app/order/sell/workSheet/workSheetProduct/groupWorkSheetProduct'
    }
    return workSheetProductStatusUrl
}

export default useWorkSheetProductStatusUrls